function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import classNames from 'classnames';
import React from 'react';
import Form from 'react-formal';
import { useIntl } from 'react-intl';
import styles from './FormControls.module.scss';

function FormMessage({
  className,
  ...props
}) {
  const {
    formatMessage
  } = useIntl();
  return React.createElement(Form.Message, _extends({}, props, {
    className: classNames(className, styles.message),
    extract: error => {
      const msg = error.message || error;
      if (typeof msg === 'string' || React.isValidElement(msg)) return msg;
      return formatMessage(msg, msg.values || error.values);
    }
  }));
}

export default FormMessage;